__webpack_require__.p = "/speak2text/";